/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAssignmentUser } from './InternalApiAssignmentUser';
import {
    InternalApiAssignmentUserFromJSON,
    InternalApiAssignmentUserFromJSONTyped,
    InternalApiAssignmentUserToJSON,
    InternalApiAssignmentUserToJSONTyped,
} from './InternalApiAssignmentUser';

/**
 * 
 * @export
 * @interface InternalApiCaseAssignment
 */
export interface InternalApiCaseAssignment {
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiCaseAssignment
     */
    assignee: InternalApiAssignmentUser;
    /**
     * 
     * @type {InternalApiAssignmentUser}
     * @memberof InternalApiCaseAssignment
     */
    assigner: InternalApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiCaseAssignment
     */
    createdAt: Date;
}

/**
 * Check if a given object implements the InternalApiCaseAssignment interface.
 */
export function instanceOfInternalApiCaseAssignment(value: object): value is InternalApiCaseAssignment {
    if (!('assignee' in value) || value['assignee'] === undefined) return false;
    if (!('assigner' in value) || value['assigner'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function InternalApiCaseAssignmentFromJSON(json: any): InternalApiCaseAssignment {
    return InternalApiCaseAssignmentFromJSONTyped(json, false);
}

export function InternalApiCaseAssignmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCaseAssignment {
    if (json == null) {
        return json;
    }
    return {
        
        'assignee': InternalApiAssignmentUserFromJSON(json['assignee']),
        'assigner': InternalApiAssignmentUserFromJSON(json['assigner']),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function InternalApiCaseAssignmentToJSON(json: any): InternalApiCaseAssignment {
    return InternalApiCaseAssignmentToJSONTyped(json, false);
}

export function InternalApiCaseAssignmentToJSONTyped(value?: InternalApiCaseAssignment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'assignee': InternalApiAssignmentUserToJSON(value['assignee']),
        'assigner': InternalApiAssignmentUserToJSON(value['assigner']),
        'createdAt': value['createdAt'].toISOString(),
    };
}

